import { useAppDispatch, useAppSelector } from "features/hooks";
import { RootState } from "features/store";
import { setDataSWOTModelWeaknesses } from "features/swotModel";
import { ChangeEvent, FC, FormEvent, useState } from "react";
import styles from "../SWOTForms.module.scss";

const SWOTModelWForm: FC = () => {
  const dispatch = useAppDispatch();
  const data: string = useAppSelector(
    (state: RootState) => state.swotModel.data.weaknesses
  );
  const [value, setValue] = useState<string>(data);

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    dispatch(setDataSWOTModelWeaknesses(value));
    alert("Đã lưu!");
  };

  return (
    <div className={styles.contentWrap}>
      <div className={styles.container}>
        <h3 className={styles.title}>
          <span className={styles.strong}>Điểm yếu</span> của tôi
        </h3>
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.formControl}>
            <label className={styles.label}>
              Đâu là những thứ bạn đang thiếu?
            </label>
            <textarea
              className={styles.input}
              name="weaknesses"
              onChange={handleChange}
              rows={25}
            >
              {value}
            </textarea>
          </div>
          <button type="submit" className={styles.btn}>
            Lưu lại
          </button>
        </form>
      </div>
    </div>
  );
};

export default SWOTModelWForm;
